import styled from '@emotion/styled';
import { DatagridWithStickyActions } from 'shared/react-admin/Datagrids/DatagridWithStickyActions/DatagridWithStickyActions';
import { getColumnStyle } from 'utils/getColumnStyle';

export const DatagridStyled = styled(DatagridWithStickyActions)({
  '& .column-originId': getColumnStyle(56),
  '& .column-roleName': { minWidth: '159px', width: '159px' },
  '& .column-alias': { minWidth: '150px', width: '150px' },
});
